import { render, staticRenderFns } from "./popup-do-category.vue?vue&type=template&id=988cb584&scoped=true"
import script from "./popup-do-category.vue?vue&type=script&lang=js"
export * from "./popup-do-category.vue?vue&type=script&lang=js"
import style0 from "./popup-do-category.vue?vue&type=style&index=0&id=988cb584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988cb584",
  null
  
)

export default component.exports